/*
 * @Author: wb_xianghongchi
 * @Date: 2023-12-13 11:37:14
 * @Email: wb_xianghongchi@meituan.com
 * @LastEditors: wb_xianghongchi
 * @LastEditTime: 2024-06-19 16:39:20
 * @Description: 
 */
export const HeaderThemeMap = {
    LIGHT: 'light',
    DARK: 'dark',
    OPCITY_LIGHT: 'opcity-light',
    OPCITY_DARK: 'opcity-dark',
}

export const ActionType = {
    DOWNLOAD: 1,
    BROWSE: 2,
    LIKE: 3,
    COLLECT: 4,
    FOLLOW: 5,
    SHARE: 6,
}

export const ActionTypeMap = {
    [ActionType.DOWNLOAD]: '下载',
    [ActionType.BROWSE]: '浏览',
    [ActionType.LIKE]: '点赞',
    [ActionType.COLLECT]: '收藏',
    [ActionType.FOLLOW]: '关注',
    [ActionType.SHARE]: '分享'
}

export const DirectoryType = {
    ADDFIRST: '新增一级分类',
    ADDSECOND: '新增二级分类',
    ADDTHIRD: '新增三级分类',
    EDIT: '编辑'
}

export const authorityType = {
    ALL: 0,
    OHTER: 1
}

export const authorityTypeMap = {
    [authorityType.ALL]: '全体美团员工可见',
    [authorityType.OHTER]: '指定部门和个人可见'
}

export const colorSet = ['#F9FBF1', '#E4E6E5', '#D9D8C6', '#F5F5DC', '#D9D3CC', '#BBD4C7', '#8D9D9D', '#ADAEA9', '#A8A395', '#D4E4E8', '#C1CED1', '#A7BFB9', '#7C7D84', '#F9FBF1', '#E4E6E5', '#D9D8C6', '#F5F5DC', '#D9D3CC', '#BBD4C7', '#ADAEA9']